import { createContext, type FC, type ReactNode, useContext, useState } from "react";

type LocationCellContextValue = {
	openLocationId: string | null;
	setOpenLocationId: (id: string | null) => void;
	weekStartDay?: number;
};

const LocationCellContext = createContext<LocationCellContextValue | null>(null);

export const LocationCellProvider: FC<{ children: ReactNode; weekStartDay?: number }> = ({ children, weekStartDay }) => {
	const [openLocationId, setOpenLocationId] = useState<string | null>(null);
	return <LocationCellContext.Provider value={{ openLocationId, setOpenLocationId, weekStartDay }}>{children}</LocationCellContext.Provider>;
};

export const useLocationCellContext = (): LocationCellContextValue => {
	const ctx = useContext(LocationCellContext);
	if (!ctx) throw new Error("useLocationCellContext must be used within LocationCellProvider");
	return ctx;
};
